import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import { Spinner } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import AppointmentOverviewContainer from "../../../../../../../../../components/AppointmentOverview/v3/components/AppointmentOverview/AppointmentOverviewContainer.js";
import { CancelAppointmentForm } from "./CancelAppointmentForm.js";
/* empty css                       */
const CancelAppointment = ({
  className,
  appointment,
  labels,
  store,
  hasError,
  isAppointmentLoading,
  returnPath,
  isStoreLoading,
  disableCancelAppointmentButton,
  isCancellationInProgress,
  onSubmit,
  ...rest
}) => {
  const { getLabel } = useIntl();
  if (isAppointmentLoading) {
    return /* @__PURE__ */ React.createElement("div", { className: "cancel-appointment__loader-wrapper" }, /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") }));
  }
  if (!appointment) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("cancel-appointment", className) }, /* @__PURE__ */ React.createElement(Heading, { component: "h3", variant: "smallest", className: "cancel-appointment--border-bottom" }, labels.title), /* @__PURE__ */ React.createElement(Heading, { variant: "smallest" }, labels.subtitle), /* @__PURE__ */ React.createElement(
    AppointmentOverviewContainer,
    {
      className: "cancel-appointment__overview",
      appointment,
      store,
      isStoreLoading
    }
  ), /* @__PURE__ */ React.createElement(Heading, { component: "h3", variant: "smallest", className: "cancel-appointment--border-bottom" }, labels.reason), /* @__PURE__ */ React.createElement(
    CancelAppointmentForm,
    {
      labels,
      hasError,
      returnPath,
      disableCancelAppointmentButton,
      onSubmit,
      isCancellationInProgress
    }
  ));
};
export {
  CancelAppointment as default
};
//# sourceMappingURL=CancelAppointment.js.map
